var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "feed-manager-table__header",
      class: {
        "feed-manager-table__header--feeds": _vm.tableType === _vm.FEEDS_TAB,
      },
    },
    [
      _vm.tableType === _vm.SCHEDULES_TAB
        ? _c("MdsButton", {
            attrs: {
              variation: "icon-only",
              icon: "refresh",
              type: "button",
              disabled: _vm.showLoader,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("refresh")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "feed-manager-table__right" },
        [
          _c("MdsSearchField", {
            staticClass: "feed-manager-table__search",
            attrs: {
              placeholder: _vm.translate(_vm.placeholder),
              size: "small",
              variation: "secondary",
            },
            on: {
              input: function ($event) {
                return _vm.$emit("search", $event)
              },
            },
          }),
          _vm._v(" "),
          _vm.tableType === _vm.FEEDS_TAB
            ? _c(
                "MdsButton",
                {
                  staticClass: "feed-manager-table__button",
                  attrs: { size: "small", variation: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("createFeed")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.translate("main.feeds.header.createFeed")))]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }